import React from "react";
import { motion } from "framer-motion";

const SplitLayout = ({ children, showBanners = true }) => {
  if (!showBanners) {
    return <div className="w-full">{children}</div>;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <motion.div
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="flex-1 min-h-0"
      >
        <div className="h-full overflow-y-auto">{children}</div>
      </motion.div>
    </div>
  );
};

export default SplitLayout;
